import countIcon from '~/assets/icons/count.svg';
import { CurrencyIcon } from '~/components/collections';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks/useWalletIcon';
import { Currency } from '~/shared';
import {
	AppAdsPlayerAvatar,
	AppAdsPlayerAvatarSize,
} from '../AppAdsPlayerAvatar';
import { IAppAdsClothesListItemProps } from './AppAdsClothesListItem.model';
import {
	StyledContainer,
	StyledCountContainer,
	StyledItemName,
	StyledPriceContainer,
} from './AppAdsClothesListItem.styled';

const AppAdsClothesListItem = ({
	itemName,
	itemSubText,
	count,
	price,
	nickName,
	active,
}: IAppAdsClothesListItemProps) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer $active={active}>
			<AppAdsPlayerAvatar
				nickName={nickName}
				size={AppAdsPlayerAvatarSize.Small}
			/>
			<StyledItemName>
				{itemName} {itemSubText && <span>({itemSubText})</span>}
			</StyledItemName>
			<Divider $direction="V" $transition style={{ opacity: 0.1 }} />
			<StyledCountContainer>
				<img src={countIcon} alt="count" />
				<Text>
					{count.toLocaleString('ru-RU')} <span>шт.</span>
				</Text>
			</StyledCountContainer>
			<Divider $direction="V" $transition style={{ opacity: 0.1 }} />
			<StyledPriceContainer>
				<Text>{price.toLocaleString('ru-RU')}</Text>
				<CurrencyIcon icon={rubleIcon} size={'sm'} />
			</StyledPriceContainer>
		</StyledContainer>
	);
};

export { AppAdsClothesListItem };
